import clsx from 'clsx';
import React, { memo, RefObject } from 'react';

import { ChatConversationMessage } from '@/components/chatConversation/chatConversation';
import PlaygroundChat from '@/components/playgroundChat/playgroundChat';
import { Heading } from '@/components/typography/heading';

import styles from '../explorer.module.scss';


type Props = {
  id: string;
  input: string;
  isWaiting: boolean;
  messages: ChatConversationMessage[];
  messagesEndRef: RefObject<HTMLDivElement | null>;
  onClickChat: ( mode: string ) => void;
  onClickStop: () => void;
  onInputChange: ( value: string ) => void;
};

function ExplorerChat( {
  id,
  input,
  isWaiting,
  messages,
  messagesEndRef,
  onClickChat,
  onClickStop,
  onInputChange
}: Props ) {
  return (
    <div className={ clsx( 'layout__col', 'overflow_hide', styles.chatPanel ) } data-testid="explorer-chat">
      <div className={ styles.chatHeader }>
        <Heading as="h3" size="sm">Chat with Explorer Agent</Heading>
      </div>
      <div className={ clsx( 'layout__col', 'overflow_hide', styles.chatBody ) }>
        <PlaygroundChat
          id={ id }
          input={ input }
          isWaiting={ isWaiting }
          messages={ messages }
          enableStructured={ false }
          messagesEndRef={ messagesEndRef }
          onClickChat={ onClickChat }
          onClickStop={ onClickStop }
          onInputChange={ onInputChange }
        />
      </div>
    </div>
  );
}

export default memo( ExplorerChat );
